import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TEST_IDS } from "@/constants/testIds";

const AVATARS = [
    "https://images.pexels.com/photos/31869537/pexels-photo-31869537.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4MzI2NDUyNHww&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/26872232/pexels-photo-26872232.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function Testimonials() {
    const { t } = useI18n();
    return (
        <section className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cyan">Loved by operators</div>
                <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl tracking-tighter text-white max-w-2xl">
                    {t.landing.testimonialsTitle}
                </h2>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4">
                    {t.landing.testimonials.map((tt, i) => (
                        <motion.div
                            key={tt.key}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: i * 0.1 }}
                            viewport={{ once: true }}
                            data-testid={TEST_IDS.landing.testimonial(tt.key)}
                            className="relative p-7 rounded-2xl bg-brand-surface border border-white/5 hover:border-white/12 transition"
                        >
                            <div className="text-brand-cyan text-4xl leading-none font-display">&ldquo;</div>
                            <p className="mt-2 text-zinc-200 leading-relaxed">{tt.quote}</p>
                            <div className="mt-6 flex items-center gap-3">
                                <img
                                    src={AVATARS[i % AVATARS.length]}
                                    alt={tt.name}
                                    className="w-10 h-10 rounded-full object-cover ring-1 ring-white/10"
                                />
                                <div>
                                    <div className="text-sm font-semibold text-white">{tt.name}</div>
                                    <div className="text-xs text-zinc-500">{tt.role}</div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
